import React, {useEffect, useState} from "react";
import {Col} from "antd";
import {
    CompanyFilter,
    SubCompanyFilter,
    PoolFilter
} from "../../_defaultComponents/FilterComponents";
import {usePoolCompanies} from "../../../hooks/usePoolCompanies";

const PoolIntensityCallbacksFilters = ({setCurrentPage, filters, setFilters}) => {
    const [filterState, setFilterState] = useState({
        poolId: filters.poolId,
        companyId: filters.companyId,
        subCompanyId: filters.subCompanyId
    });

    const {filterCompany, isLoading} = usePoolCompanies(filterState.poolId);

    // FilterState değiştiğinde parent'a bildir
    useEffect(() => {
        if (JSON.stringify(filters) !== JSON.stringify(filterState)) {
            setFilters(filterState);
            setCurrentPage(1);
        }
    }, [JSON.stringify(filterState)]);

    const handlePoolChange = value => {
        setFilterState({
            poolId: value,
            companyId: undefined,
            subCompanyId: undefined
        });
    };

    const handleCompanyChange = value => {
        setFilterState(prev => ({
            ...prev,
            companyId: value,
            subCompanyId: undefined
        }));
    };

    const handleSubCompanyChange = value => {
        setFilterState(prev => ({
            ...prev,
            subCompanyId: value
        }));
    };

    return (
        <React.Fragment>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <PoolFilter
                    showAllOption={false}
                    value={filterState.poolId}
                    allowClear={true}
                    onChange={handlePoolChange}
                    showSearch={true}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <CompanyFilter
                    showAllOption={false}
                    showPoolOption={false}
                    value={filterState.companyId}
                    onChange={handleCompanyChange}
                    optionFilter={filterCompany}
                    loading={isLoading}
                    disabled={!filterState.poolId}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <SubCompanyFilter
                    company={filterState.companyId}
                    value={filterState.subCompanyId}
                    onChange={handleSubCompanyChange}
                    disabled={!filterState.companyId}
                    initialCall={false}
                    showAllOption={false}
                    allowClear={true}
                    showSearch={true}
                />
            </Col>
        </React.Fragment>
    );
};

export default PoolIntensityCallbacksFilters;
